<template>
    <div class="thumnail-desc pb-60">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <ul class="main-thumb-desc nav">
                        <li><span class="a_bottom active" :class="{ 'in active': activeTab === true}" @click="active()" >توضیحات</span></li>
                        <li><span  class="a_bottom" :class="{ 'in active': activeTab2 === true}" @click="active2()" >مشخصات</span></li>

                        <template v-if="data_product.product_pdf!='[]'" v-for="pdf in data_product.product_pdf">
                        <li v-if="pdf.pdf_1 !=null"><a :href="'/product-pdf/'+pdf.pdf_1" target="_blank">دانلود کاتالوگ</a></li>
                        <li v-if="pdf.pdf_2 !=null"><a :href="'/product-pdf/'+pdf.pdf_2" target="_blank">دانلود لیست قیمت</a></li>
                        </template>
                        <li><span  class="a_bottom" :class="{ 'in active': activeTab3 === true}" @click="active4()" >ویدیو</span></li>
                        <li><span  class="a_bottom"  :class="{ 'in active': activeTab4 === true}" @click="active3()">نظرکاربران</span></li>
                    </ul>
                    <!-- Product Thumbnail Tab Content Start -->
                    <div class="tab-content thumb-content border-default">
                        <div  class="tab-pane" :class="{ 'in active': activeTab === true}">
                            <p v-html="data_product.long_dec" style="direction: rtl; text-align: right; margin-bottom: 20px;">

                            </p>

                            <img v-if="data_product.dec_img1!=null" :src="'/img-product/'+data_product.dec_img1">


                            <img v-if="data_product.dec_img2!=null" :src="'/img-product/'+data_product.dec_img2">


                            <img v-if="data_product.dec_img3!=null" :src="'/img-product/'+data_product.dec_img3">


                            <p v-if="data_product.long_dec2!=null">{{data_product.long_dec2}}</p>

                        </div>
                        <div  class="tab-pane" :class="{ 'in active': activeTab2 === true}">
                            <!-- Reviews Start -->



                            <div class="review ">

                                <div class="table-responsive">

                                    <table class="table table-striped ">
                                        <thead>
                                        <tr>
                                            <template v-for="title_dec in data_product.productdec_title">
                                                <template v-if="title_dec.title_count =='11'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center; padding-left: 45px; padding-right: 45px;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_6}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_7}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_8}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_9}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_10}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_11}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='10'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_6}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_7}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_8}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_9}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_10}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='9'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_6}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_7}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_8}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_9}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='8'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_6}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_7}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_8}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='7'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_6}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_7}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='6'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_6}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='5'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_5}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='4'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_4}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='3'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_3}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='2'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_2}}</th>
                                                </template>
                                                <template v-if="title_dec.title_count =='1'">
                                                    <th scope="col" style="text-align: center;">{{title_dec.title_1}}</th>
                                                </template>
                                            </template>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template v-for="dec in data_product.product_dec">
                                        <template v-for="title_dec in data_product.productdec_title">
                                        <template v-if="title_dec.title_count=='11'">
                                        <tr>
                                            <td style="text-align: center;">{{dec.dec_1}}</td>
                                            <td style="text-align: center; font-size: 14px;">{{dec.dec_2}}</td>
                                            <td style="text-align: center;">{{dec.dec_3}}</td>
                                            <td style="text-align: center;">{{dec.dec_4}}</td>
                                            <td style="text-align: center;">{{dec.dec_5}}</td>
                                            <td style="text-align: center;">{{dec.dec_6}}</td>
                                            <td style="text-align: center;">{{dec.dec_7}}</td>
                                            <td style="text-align: center;">{{dec.dec_8}}</td>
                                            <td style="text-align: center;">{{dec.dec_9}}</td>
                                            <td style="text-align: center;">{{dec.dec_10}}</td>
                                            <td style="text-align: center;">{{dec.dec_11}}</td>
                                        </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='10'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                    <td style="text-align: center;">{{dec.dec_5}}</td>
                                                    <td style="text-align: center;">{{dec.dec_6}}</td>
                                                    <td style="text-align: center;">{{dec.dec_7}}</td>
                                                    <td style="text-align: center;">{{dec.dec_8}}</td>
                                                    <td style="text-align: center;">{{dec.dec_9}}</td>
                                                    <td style="text-align: center;">{{dec.dec_10}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='9'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                    <td style="text-align: center;">{{dec.dec_5}}</td>
                                                    <td style="text-align: center;">{{dec.dec_6}}</td>
                                                    <td style="text-align: center;">{{dec.dec_7}}</td>
                                                    <td style="text-align: center;">{{dec.dec_8}}</td>
                                                    <td style="text-align: center;">{{dec.dec_9}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='8'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                    <td style="text-align: center;">{{dec.dec_5}}</td>
                                                    <td style="text-align: center;">{{dec.dec_6}}</td>
                                                    <td style="text-align: center;">{{dec.dec_7}}</td>
                                                    <td style="text-align: center;">{{dec.dec_8}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='7'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                    <td style="text-align: center;">{{dec.dec_5}}</td>
                                                    <td style="text-align: center;">{{dec.dec_6}}</td>
                                                    <td style="text-align: center;">{{dec.dec_7}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='6'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                    <td style="text-align: center;">{{dec.dec_5}}</td>
                                                    <td style="text-align: center;">{{dec.dec_6}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='5'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                    <td style="text-align: center;">{{dec.dec_5}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='4'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                    <td style="text-align: center;">{{dec.dec_4}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='3'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                    <td style="text-align: center;">{{dec.dec_3}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='2'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                    <td style="text-align: center;">{{dec.dec_2}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="title_dec.title_count=='1'">
                                                <tr>
                                                    <td style="text-align: center;">{{dec.dec_1}}</td>
                                                </tr>
                                            </template>
                                           </template>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                        <div  class="tab-pane" :class="{ 'in active': activeTab3 === true}">
                            <div class="review" style="direction: rtl">
                                <div class="group-title">
                                    <h2>نظرات کابران</h2>
                                </div>
                                <template v-for="post in data_product.post">
                                <h3 class="review-mini-title">{{post.name}}</h3>
                                <ul class="review-list">
                                    <!-- Single Review List Start -->
                                    <li>{{post.post}}</li>
                                </ul>
                                     </template>
                            </div>
                            <div v-show="alertsend" class="alert alert-success" style="text-align: right;">
                                <i class="fa fa-archive"></i>
                                {{ alertsend }}</div>
                            <div class="riview-field mt-40">
                                <form @submit.prevent="savePost()"  method="post" action="/post/{{data_product.id}}/{{data_product.slug}}">
                                    <div class="form-group">
                                        <label class="req" for="sure-name">:نام شما</label>
                                        <input type="text" class="form-control" v-model="formPost.name" id="sure-name" required="required">
                                    </div>
                                    <div class="form-group">
                                        <label class="req" for="subject">:ایمیل</label>
                                        <input type="email" name="email" class="form-control" v-model="formPost.email" id="subject" required="required">
                                    </div>
                                    <div class="form-group">
                                        <label class="req" for="comments">:بررسی شما</label>
                                        <textarea class="form-control" name="text" rows="5" v-model="formPost.text" id="comments" required="required"></textarea>
                                    </div>
                                    <button type="submit" class="btn-submit">ادامه</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <!-- Product Thumbnail Tab Content End -->

                </div>
            </div>
            <!-- Row End -->
        </div>
        <!-- Container End -->
    </div>
</template>

<script>

    import axios from "axios";
    import {reactive,ref} from "vue";
    export default {
        name: "DesProduct",
        props: ['product'],
        setup(props) {
            const data_product = reactive(props.product);
            const formPost = reactive([{name:'',text:'',email:''}]);
            const id = ref(data_product.id);
            const slug = ref(data_product.slug);
            const activeTab = ref(true);
            const activeTab2 = ref(false);
            const activeTab3 = ref(false);
            const activeTab4 = ref(false);
            const alertsend = ref(null);
            const savePost = async() =>{
                    try {
                        await axios.post('/api/postsform',{
                            name: formPost.name,
                            text: formPost.text,
                            email: formPost.email,
                            id: id,
                            slug: slug,
                        })
                            .then(res => {
                              //  if(res this.state.)
                               // console.log(res);
                                if(res.status === 200) {
                                    alertsend.value='پیام دخیره شد'
                                }
                            })
                    }catch (e) {
                        console.log(e);
                    }
                    formPost.name=''
                    formPost.text=''
                    formPost.email=''

            }

            const active = () =>
            {
                activeTab.value=true;
                activeTab2.value=false;
                activeTab3.value=false;
                activeTab4.value=false;
            };
            const active2 = () =>
            {
                activeTab.value=false;
                activeTab2.value=true;
                activeTab3.value=false;
                activeTab4.value=false;
            };
            const active3 = () =>
            {
                activeTab.value=false;
                activeTab2.value=false;
                activeTab3.value=true;
                activeTab4.value=false;
            };
            const active4 = () =>
            {
                activeTab.value=false;
                activeTab2.value=false;
                activeTab3.value=false;
                activeTab4.value=true;
            };

            return{
                data_product,
                active4,
                active2,
                active3,
                active,
                activeTab,
                activeTab2,
                activeTab3,
                activeTab4,
                savePost,
                formPost,
                alertsend,
            }
        },

    }
</script>

<style scoped>
    .a_bottom {
        font-weight: 500;
        line-height: 30px;
        font-size: 15px;
        color: #444;
        background: #f0f0f0;
        border: 1px solid #ebebeb;
        padding: 0 20px;
        height: 30px;
        display: inline-block;
        text-transform: uppercase;
        cursor: pointer;
    }
</style>
